module.exports = __webpack_public_path__ + "img/cover.528cde42.jpg";